import { render } from "./button-pagination.vue?vue&type=template&id=663f240e&scoped=true&lang=html"
import script from "./button-pagination.vue?vue&type=script&lang=js"
export * from "./button-pagination.vue?vue&type=script&lang=js"

import "./button-pagination.vue?vue&type=style&index=0&id=663f240e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-663f240e"]])

export default __exports__